import React from "react";
import { motion } from "framer-motion";
import { Phone } from "lucide-react";

const PHONE = "561-502-6769";

export default function StickyCall() {
  return (
    <motion.a
      href={`tel:${PHONE}`}
      data-testid="sticky-call"
      initial={{ y: 80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 1.6, duration: 0.7, ease: [0.7, 0, 0.2, 1] }}
      className="lg:hidden fixed bottom-4 left-4 right-4 z-40 bg-[#E31E24] text-white px-5 py-4 flex items-center justify-between shadow-2xl shadow-[#E31E24]/30"
    >
      <span className="font-anton uppercase tracking-[0.14em]">Call Strive</span>
      <span className="flex items-center gap-2 font-mono2 text-sm">
        <Phone size={16} /> {PHONE}
      </span>
    </motion.a>
  );
}
